import { render, staticRenderFns } from "./OrderMini.vue?vue&type=template&id=230a8830&scoped=true&"
import script from "./OrderMini.vue?vue&type=script&lang=js&"
export * from "./OrderMini.vue?vue&type=script&lang=js&"
import style0 from "./OrderMini.vue?vue&type=style&index=0&id=230a8830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a8830",
  null
  
)

export default component.exports